import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-icon-link',
    templateUrl: './icon-link.component.html',
    styleUrls: ['./icon-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IconLinkComponent {
    @Input() symbol: string;
    @Input() routerLink: string;
    @Input() label: string;
    @Input() href: string;
    @Input() target: string;
}
